import { progressColor } from "../../utils/profileHelpers";

/**
 * ProgressBar
 * A simple horizontal bar that colors itself based on completion %.
 *
 * Props:
 *   current  – current value
 *   target   – target value
 *   height   – bar height in px (default 8)
 *   color    – override bar color (auto-computed from pct if omitted)
 */
export default function ProgressBar({ current, target, height = 8, color }) {
  const pct      = target > 0 ? Math.min(Math.round((current / target) * 100), 100) : 0;
  const barColor = color ?? progressColor(pct);

  return (
    <div style={{ background: "#f1f5f9", borderRadius: 6, height, overflow: "hidden" }}>
      <div style={{
        width: `${pct}%`, height: "100%",
        background: barColor, borderRadius: 6,
        transition: "width 0.4s",
      }} />
    </div>
  );
}